module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/icon-align-to-top.0b0309e1bfed5cc9aadafffee425688c.svg";